import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { BookingAdressAddressFragment } from '../../../../lib/graphql'
import { Nullable } from '../../../../types'

const BookingAdress = ({
  adress,
  privateTitle,
}: {
  adress?: Nullable<BookingAdressAddressFragment>
  privateTitle: string
}) => {
  const fullAdress =
    adress?.street + ', ' + adress?.postalCode + ' ' + adress?.city
  return (
    <div className={s.adress}>
      <div className={s.title}>
        <FormattedMessage
          id='ui.BookingAdress.address'
          defaultMessage='Adresse'
        />
      </div>
      <span>{privateTitle}</span>
      <span>{fullAdress}</span>
    </div>
  )
}

export default BookingAdress
